import { API_URL } from '../../../app-config/constants';
import type MiniUser from '../../../types/MiniUser';
import { get } from '../request';

const BASE_URL = `${API_URL}/ai-observer`;

export interface PromptRecord {
    id: string;
    type: 'WRITING' | 'SUMMARY';
    createdAt: number;
    prompt: string;
    input: string;
    output: string;
    user: MiniUser;
}

export function getPromptRecordsForUser(userId: string) {
    return get<PromptRecord[]>(`${BASE_URL}/user/${userId}`);
}

export function getPromptRecordsForCompany(companyId: string) {
    return get<PromptRecord[]>(`${BASE_URL}/company/${companyId}`);
}
